import React from 'react';
import { Link } from 'react-router-dom';
import {ArrowLeft, CheckCircle} from 'lucide-react';

const guides = [
  {
    destination: 'Japan',
    essentials: [
      'Learn basic Japanese phrases (hello, thank you, excuse me)',
      'Get a JR Pass if traveling between cities',
      'Cash is king - many places don\'t accept cards',
      'Remove shoes when entering homes and some restaurants',
      'Bowing is a sign of respect',
      'No tipping culture',
      'Tattoos may restrict access to hot springs'
    ],
    musthaves: ['IC Card (Suica/Pasmo)', 'Pocket WiFi', 'Japan Rail Pass', 'Cash (¥10,000+)']
  },
  {
    destination: 'Singapore',
    essentials: [
      'English is widely spoken',
      'Public transport is excellent and affordable',
      'Chewing gum is illegal',
      'Don\'t jaywalk - hefty fines apply',
      'Tipping is not expected',
      'Hawker centers offer cheap, delicious food',
      'Always carry tissue paper (some restrooms don\'t provide)'
    ],
    musthaves: ['EZ-Link Card', 'Light clothing', 'Umbrella', 'Hand sanitizer']
  },
  {
    destination: 'Hong Kong',
    essentials: [
      'Octopus Card for all transport and convenience stores',
      'English and Cantonese widely spoken',
      'Very walkable city with excellent MTR',
      'Tipping around 10% in restaurants',
      'Stay right on escalators',
      'Dim sum is a must-try experience',
      'Humid summers, mild winters'
    ],
    musthaves: ['Octopus Card', 'Comfortable shoes', 'Light jacket', 'Reusable water bottle']
  },
  {
    destination: 'USA (Orlando)',
    essentials: [
      'Theme parks require full days - arrive early',
      'Express Passes save hours of wait time',
      'Stay hydrated - Florida heat is intense',
      'Book dining reservations 60 days ahead',
      'Tipping 15-20% is expected',
      'Rental car highly recommended',
      'Download park apps for wait times'
    ],
    musthaves: ['Sunscreen', 'Portable charger', 'Park tickets', 'Comfortable shoes']
  }
];

export default function FirstTime() {
  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      {/* Header */}
      <div className="bg-gradient-to-br from-[#0A2540] to-[#1a3a5f] text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to="/guides" className="inline-flex items-center text-gray-200 hover:text-white mb-4 transition-colors">
            <ArrowLeft className="w-5 h-5 mr-2" />
            Back to Guides
          </Link>
          <h1 className="text-5xl font-bold mb-4">First-Time Visitor Guides</h1>
          <p className="text-xl text-gray-200">Essential tips to make your first visit smooth and memorable</p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {guides.map((guide, index) => (
          <div key={index} className="bg-white rounded-xl shadow-lg p-8 mb-8">
            <h2 className="text-3xl font-bold text-[#0A2540] mb-6">{guide.destination}</h2>
            
            <div className="mb-8">
              <h3 className="text-2xl font-semibold text-[#FF6B35] mb-4">Essential Tips</h3>
              <ul className="space-y-3">
                {guide.essentials.map((tip, i) => (
                  <li key={i} className="flex items-start">
                    <CheckCircle className="w-6 h-6 text-[#4A90E2] mr-3 flex-shrink-0 mt-0.5" />
                    <span className="text-gray-700">{tip}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="text-2xl font-semibold text-[#FF6B35] mb-4">Must-Have Items</h3>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                {guide.musthaves.map((item, i) => (
                  <div key={i} className="bg-[#F5F5F5] rounded-lg p-4 text-center">
                    <span className="text-[#0A2540] font-medium">{item}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}